import { UserManager } from "oidc-client-ts";

export const oidcConfig: any = {
  authority: import.meta.env.VITE_PUBLIC_APP_AUTHORITY,
  post_logout_redirect_uri: import.meta.env
    .VITE_PUBLIC_APP_POST_LOGOUT_REDIRECT_URI,
  client_id: import.meta.env.VITE_PUBLIC_APP_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_PUBLIC_APP_REDIRECT_URI,
  response_type: import.meta.env.VITE_PUBLIC_APP_RESPONSE_TYPE,
  scope: import.meta.env.VITE_PUBLIC_APP_SCOPE,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
export const userManager = new UserManager(oidcConfig);
